<template>
  <div class="banner"></div>
</template>

<script>
export default {
  name: 'Banner',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  width: 100%;
  height: 1.041667rem;
  background: url(../assets/images/banner.jpg) no-repeat;
  background-size: 10rem 1.041667rem;
}
</style>
